import { FieldModel, ValidateJSModel } from 'forms/shared/types';

const currencyModelValidator: ValidateJSModel<FieldModel> = {
  value: {
    presence: true,

    /* Add validation for total amount range (1 - 2,147,483,647) */
    numericality: {
      onlyInteger: true,
      greaterThanOrEqualTo: 1,
      lessThanOrEqualTo: 2147483647,
      notGreaterThanOrEqualTo: 'error.currency.min',
      notLessThanOrEqualTo: 'error.currency.max',
      notInteger: 'error.currency.notInteger',
    },
  },
  name: {},
};

export default currencyModelValidator;
